import { useIsMobile } from '@/hooks/use-mobile'
import { DashboardStatsDesktop } from './DashboardStatsDesktop'
import { DashboardStatsMobile } from './DashboardStatsMobile'
import { DashboardStatsProps } from './DashboardStatsBase'

/**
 * Dashboard Stats component
 * Renders mobile or desktop version based on screen size
 * 
 * Uses component split pattern for significantly different layouts:
 * - Mobile: 2-column grid with row spans
 * - Desktop: 3-column grid with charts
 * 
 * @example
 * ```tsx
 * <DashboardStats
 *   profile={profile}
 *   totalProjects={100}
 *   totalOrderbookValue={1000000}
 *   averageDiscount={25.5}
 *   buyOrders={50}
 *   sellOrders={30}
 *   loading={false}
 *   totalProjectsMonthlyAvg={data.monthlyAvg}
 *   orderbookMonthlyAvg={data.orderbookAvg}
 * />
 * ```
 */
export const DashboardStats = (props: DashboardStatsProps) => {
  const isMobile = useIsMobile()

  if (isMobile) {
    return <DashboardStatsMobile {...props} />
  }

  return <DashboardStatsDesktop {...props} />
}

